import React, { useState, useRef, FC } from 'react';
import styled from '@emotion/styled';

import { useTableUniverse, useTableApi } from '~Components/TableUniverse';
import useModal from '~ComponentsImproved/Modal/useModal';
import Modal from '~ComponentsImproved/Modal';
import { useSelector, useI18n } from '~Hooks';
import * as actions from '~actions';
import { useDispatch } from 'react-redux';
import { handyBreakpoint } from '~Styles/breakpoints';

const InnerWrapper = styled.div<{
  top?: number;
}>`
  position: absolute;
  top: ${({ top }) => top || 70}px;
  width: 400px;
  left: calc(50% - 200px);
  height: 100px;
  padding: 20px;
  transition: all 200ms ease-out;
  animation: fade-and-translate-in 200ms cubic-bezier(0.215, 0.61, 0.355, 1);

  ${handyBreakpoint} {
    width: calc(100% - 40px);
    left: 12px;
  }
`;

const Input = styled.input`
  box-sizing: border-box;
  font-size: 21px;
  padding: 15px;
  width: 400px;
  border: 0;
  outline: 0;
  margin: 0;
  border-radius: 2px;
  position: relative;
  z-index: 10;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.9);

  ${handyBreakpoint} {
    width: calc(100% - 30px);
  }
`;

const Result = styled.div`
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.8);
  color: #333;
  font-size: 19px;
  padding: 15px;
  width: 380px;
  position: relative;
  z-index: 9;
  margin: 0 10px;
  margin-bottom: 1px;

  ${handyBreakpoint} {
    width: calc(100% - 48px);
  }
`;

const Name = styled.div<{ active: boolean }>`
  font-weight: bold;
  ${({ active }) => active && 'color: #209946;'}
`;

interface Props {
  isShowing: boolean;
  onClose: () => void;
  selectedCheque: string | null;
}

const ChangeChequeOwner: FC<Props> = ({ isShowing, onClose, selectedCheque }) => {
  const { i18n } = useI18n();
  const dispatch = useDispatch();

  const companyStaff = useSelector((state) => state.companyStaff?.staffs) || [];

  const tableUniverse = useTableUniverse();
  const cheque = tableUniverse?.cheques.find((c) => c.id === selectedCheque);
  const chequeOwnerId = cheque?.owner || '';
  const tableApi = useTableApi();

  const input = useRef<HTMLInputElement | null>(null);
  const [search, setSearch] = useState('');

  const handleItemClicked = (staffId: string) => {
    if (!selectedCheque || chequeOwnerId === staffId) return;

    tableApi.setChequeOwner(selectedCheque, staffId);
    onClose();
    dispatch(actions.addToast(i18n('TOAST.Cheque.OwnerChanged'), true));
  };

  const targets = companyStaff
    .filter((cs) => {
      return cs.name.toLowerCase().includes(search);
    })
    .slice(0, 3);

  return (
    <Modal isShowing={isShowing} hide={onClose}>
      <InnerWrapper>
        <Input
          ref={input}
          value={search}
          onChange={(e) => setSearch(e.target.value.toLowerCase())}
          placeholder={i18n('TM.SearchForStaff')}
        />

        {targets.map((target) => (
          <Result
            key={target.id}
            onClick={() => {
              handleItemClicked(target.id);
            }}>
            <Name active={chequeOwnerId === target.id}>{target.name}</Name>
          </Result>
        ))}
      </InnerWrapper>
    </Modal>
  );
};

export default ChangeChequeOwner;
